import { connectInfiniteHits } from 'instantsearch.js/es/connectors';

// Create the render function
const renderInfiniteHits = (renderOptions, isFirstRender) => {
    const { hits, widgetParams, isLastPage, showMore } = renderOptions;

    // Si c'est le premier rendu, on ajoute l'event listener sur le bouton pour afficher plus de résultats
    if (isFirstRender) {
        chargerPlus.addEventListener('click', () => {
            showMore();
        });
    }

    // Si on a atteint la dernière page, on désactive le bouton pour charger plus de résultats
    if (isLastPage && !isFirstRender) {
        chargerPlus.removeEventListener('click', () => {
            showMore();
        });
        chargerPlus.classList.add('disabled');
        chargerPlus.setAttribute('disabled', 'disabled');
        chargerPlus.style.cursor = 'not-allowed';
    }

    document.querySelector(widgetParams.container).innerHTML = `${hits
        .map(
            (item) => `<li>
            <a href="${item.url}" class="page_list-item" >
                <h2 class="page_list-titre titre3">${item.poste}</h2>
                <div class="page_list-detail">
                    <span class="tag"><i class="icon-map-marker-alt-solid"></i>${
                        item.ville
                    }</span>
                    <span class="tag"><i class="icon-pen-nib-solid"></i>${
                        item.contrat
                    }</span>
                    <span class="tag"><i class="icon-clock"></i>
                        ${new Date(
                            item.dateOffre.replace(/-/g, '/')
                        ).toLocaleDateString(undefined, {
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                        })}
                    </span>
                </div>
            </a>
        </li>`
        )
        .join('')}`;
};

export const customInfiniteHits = connectInfiniteHits(renderInfiniteHits);
